export default "__VITE_PUBLIC_ASSET__cd89fdab__"